import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

const statusLabel = {
  DRAFT: 'Rascunho',
  QUEUED: 'Na fila',
  PRINTING: 'Imprimindo',
  COMPLETED: 'Concluído',
  FAILED: 'Falhou',
  CANCELED: 'Cancelado',
};

const badges = {
  COMPLETED: 'bg-primary-container text-on-primary-container',
  FAILED: 'bg-error-container text-on-error-container',
  QUEUED: 'bg-surface-container-high text-on-surface-variant',
  PRINTING: 'bg-secondary-container text-on-secondary-container',
  DRAFT: 'bg-surface-variant text-on-surface-variant',
  CANCELED: 'bg-surface-variant text-on-surface-variant',
};

function fmtDate(value) {
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' }).format(new Date(value));
}

export default function History() {
  const [jobs, setJobs] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .listPrintJobs()
      .then(setJobs)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="flex flex-col gap-base">
      <div>
        <h1 className="studio-uniform-title font-h2 text-h2 text-on-surface">Histórico e Logs de impressão</h1>
        <p className="font-body-md text-body-md text-on-surface-variant mt-2">
          Auditoria de todos os trabalhos com rastreabilidade e reimpressão.
        </p>
      </div>

      {error && <p className="text-[11px] text-error">{error}</p>}

      <div className="bg-surface rounded-2xl shadow-sm overflow-hidden flex flex-col">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-surface-container-lowest text-on-surface-variant font-label-sm text-label-sm uppercase tracking-wider">
                <th className="px-6 py-4 font-semibold">Job</th>
                <th className="px-6 py-4 font-semibold">Etiqueta</th>
                <th className="px-6 py-4 font-semibold">Usuário</th>
                <th className="px-6 py-4 font-semibold">Qtd</th>
                <th className="px-6 py-4 font-semibold">Impressora</th>
                <th className="px-6 py-4 font-semibold">Data</th>
                <th className="px-6 py-4 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-surface-container-highest font-body-md text-body-md text-on-surface">
              {loading ? (
                <tr>
                  <td colSpan={7} className="px-6 py-6 text-center text-on-surface-variant">
                    Carregando…
                  </td>
                </tr>
              ) : jobs.length === 0 ? (
                <tr>
                  <td colSpan={7} className="px-6 py-6 text-center text-on-surface-variant">
                    Nenhum trabalho de impressão registrado ainda.
                  </td>
                </tr>
              ) : (
                jobs.map((job) => (
                  <tr key={job.id} className="hover:bg-surface-container-low transition-colors">
                    <td className="px-6 py-4 font-semibold">{job.id.slice(-8).toUpperCase()}</td>
                    <td className="px-6 py-4 text-on-surface-variant">{job.template?.name || 'Sem etiqueta'}</td>
                    <td className="px-6 py-4">{job.createdBy?.name || '—'}</td>
                    <td className="px-6 py-4">
                      {job.quantity}
                      {job.copies > 1 ? ` (x${job.copies})` : ''}
                    </td>
                    <td className="px-6 py-4 text-on-surface-variant">{job.printerName || '—'}</td>
                    <td className="px-6 py-4 text-on-surface-variant text-[11px]">{fmtDate(job.createdAt)}</td>
                    <td className="px-6 py-4">
                      <span className={`inline-flex items-center px-3 py-1 rounded-full font-label-sm text-label-sm capitalize ${badges[job.status] || 'bg-surface-variant text-on-surface-variant'}`}>
                        {statusLabel[job.status] || job.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <div className="bg-surface-container-low px-6 py-4 flex items-center justify-between mt-auto">
          <span className="font-label-sm text-label-sm text-on-surface-variant">{jobs.length} trabalho(s) registrado(s)</span>
        </div>
      </div>
    </div>
  );
}
